export default __webpack_public_path__ + "static/media/boost_converter_pmos.e3299922.svg";